import { render, staticRenderFns } from "./GCash.vue?vue&type=template&id=95c54d10"
import script from "./GCash.vue?vue&type=script&lang=js"
export * from "./GCash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports